export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[500px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20cozy%20reading%20space%20with%20bookshelves%20filled%20with%20colorful%20manga%20volumes%2C%20a%20comfortable%20reading%20chair%2C%20soft%20warm%20lighting%20from%20a%20desk%20lamp%2C%20digital%20tablet%20on%20a%20wooden%20table%2C%20plants%20for%20decoration%2C%20artistic%20atmosphere%2C%20warm%20wood%20tones%2C%20inviting%20composition&width=1000&height=750&seq=about-platform-01&orientation=landscape"
                alt="皮皮漫画平台介绍 - 温馨阅读空间"
                title="皮皮漫画平台介绍"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于皮皮漫画</h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              皮皮漫画成立于2020年，是国内领先的漫画在线阅读平台，致力于为广大漫画爱好者提供高质量的韩漫、日漫与国漫内容。我们与多家国内外漫画版权方、汉化组及原创作者建立了深度合作关系，确保平台内容的正版化与多样性。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              皮皮漫画韩漫频道涵盖恋爱、奇幻、悬疑等多个热门类型，皮皮漫画日漫专区收录经典与最新连载，皮皮漫画国漫类型大全则汇聚了国产漫画的精华。无论你是资深漫迷还是新手入坑，在这里都能找到属于你的阅读乐趣。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">2020年</div>
                <div className="text-xs text-foreground-500 mt-1">成立时间</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">注册用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading text-primary-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}